// Deprecated: constants moved to API-driven enums. Keep this file as a minimal placeholder
// to avoid breaking imports during migration. Do not add new constants here.

export const DEPRECATED_CONSTANTS_REMOVED = true;

export const DEFAULT_CACHE_TIME = 10; // 10 milliseconds

export const USER_ROLES = [
  { value: "Super", label: "Super Admin" },
  { value: "Admin", label: "Admin" },
  { value: "Employee", label: "Employee" },
  { value: "Finance", label: "Finance" },
  { value: "User", label: "User" },
];

export const EMPLOYEE_ROLES = [
  "Team Member",
  "Sales Representative",
  "Manager",
  "Technical Lead",
  "Developer",
  "Qualifier",
  "Designer",
  "Project Manager",
  "Account Manager",
];

export const VENDOR_CATEGORY_OPTIONS = [
  { label: "Technology", value: "Technology" },
  { label: "Design", value: "Design" },
  { label: "Marketing", value: "Marketing" },
];
